// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1_x7l","colCheckbox":"styles_colCheckbox__1yYYP"};